import { useState } from 'react';
import { OrgUsers } from './OrgUsers.tsx';
import { FormsBuilder } from './FormsBuilder.tsx';
import { dv } from '../i18n/dv.ts';

type Tab = 'users' | 'forms';

export function Settings(): JSX.Element {
  const [tab, setTab] = useState<Tab>('users');

  return (
    <div className="page space-y-6">
      <header>
        <h1 className="font-serif text-3xl tracking-tight">{dv.settings.title}</h1>
      </header>

      <div className="flex gap-2 border-b border-border">
        <button
          type="button"
          onClick={() => setTab('users')}
          aria-pressed={tab === 'users'}
          className={`-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
            tab === 'users' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'
          }`}
        >
          {dv.settings.tabUsers}
        </button>
        <button
          type="button"
          onClick={() => setTab('forms')}
          aria-pressed={tab === 'forms'}
          className={`-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
            tab === 'forms' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'
          }`}
        >
          {dv.settings.tabForms}
        </button>
      </div>

      {tab === 'users' ? <OrgUsers /> : <FormsBuilder />}
    </div>
  );
}
